<template>
  <SnowDataPoint
    label="Base Depth"
    :label-class-names="labelClassNames"
    :left-align="leftAlign"
    :responsive-row="responsiveRow"
    :value-class-names="myValueClassNames"
  >
    <font-awesome-icon
      v-if="!isAllAccess && isEstimated"
      :icon="['fas', 'lock']"
    />
    <span
      v-else
    >
      {{ baseDepth }}
    </span>
  </SnowDataPoint>
</template>

<script>
/* eslint camelcase: off */
import { mapState } from 'pinia';
import {
  dataNotAvailable,
  formatSnow,
  getLastItem,
  isEstimated,
  safeRound,
} from '@@/utils/CommonUtils';
import { useMetaStore } from '@@/stores/Meta';
import { useUserStore } from '@@/stores/User';

export default {
  name: 'SnowBaseDepthDataPoint',

  props: {
    leftAlign: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
    responsiveRow: {
      type: Boolean,
      default: false,
    },
    valueClassNames: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapState(useMetaStore, ['dataSourcesById', 'locationTypesById', 'getPowderAlert']),
    ...mapState(useUserStore, ['isAllAccess']),
    ...mapState(useUserStore, { units: (state) => state.preferences.units }),

    baseDepth() {
      const { snow_depth } = getLastItem(this.location.history_snow_daily, {});
      return formatSnow(safeRound(snow_depth), this.units, true);
    },

    isEstimated() {
      return isEstimated(this.location, this.dataSourcesById);
    },

    labelClassNames() {
      return this.isEstimated ? 'estimated-border' : null;
    },

    myValueClassNames() {
      if (!this.isAllAccess && this.isEstimated) {
        return `all-access-color ${this.valueClassNames}`;
      }

      if (this.baseDepth === dataNotAvailable) {
        return `text-light-color ${this.valueClassNames}`;
      }

      return this.valueClassNames;
    },
  },
};
</script>
